import { render, staticRenderFns } from "./ImportarGruposSignatariosTabela.vue?vue&type=template&id=12c410ff"
import script from "./ImportarGruposSignatariosTabela.vue?vue&type=script&lang=js"
export * from "./ImportarGruposSignatariosTabela.vue?vue&type=script&lang=js"
import style0 from "./ImportarGruposSignatariosTabela.vue?vue&type=style&index=0&id=12c410ff&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports